function propCheck(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}

export { propCheck }
